import { useEffect } from 'react';

/**
 * Syncs the actual visible viewport height to a `--app-height` CSS custom
 * property on `<html>`. On iOS Safari/PWA, `visualViewport.height` shrinks
 * when the keyboard opens but `visualViewport.offsetTop` may also be non-zero
 * (Safari scrolls the visual viewport). The usable height is
 * `height + offsetTop` — this gives us the full distance from the top of the
 * page to the top of the keyboard.
 *
 * Requires the root layout to use `height: var(--app-height, 100dvh)`.
 */
export function useIOSKeyboard(): void {
  useEffect(() => {
    const vv = window.visualViewport;
    if (!vv) return;

    const update = () => {
      // height = visible area; offsetTop = how far the viewport has scrolled.
      // Together they give the full usable vertical space from page top to keyboard.
      const h = vv.height + vv.offsetTop;
      document.documentElement.style.setProperty('--app-height', `${h}px`);
    };

    update();
    vv.addEventListener('resize', update);
    vv.addEventListener('scroll', update);

    return () => {
      vv.removeEventListener('resize', update);
      vv.removeEventListener('scroll', update);
    };
  }, []);
}
